import $ from "jquery";
class Modal {

    run() {
        this.videoModal();
    }

    videoModal() {
        //Case Study
        $(".videoModal").click(function () {
            $('.csVideo').trigger('pause');
        });

        $('a.video-toggler').on('click',function(event){
            event.preventDefault();

            var dataVideo = $(this).data('video');
            var posterVideo = $(this).data('poster');
            var postTitle = $(this).data('post-title');

            if($(this).data('kind') == 'embeded' ){
                var embedElement = '<div class="embed-responsive embed-responsive-16by9"><iframe class="video-embed embed-responsive-item" src="https://www.youtube-nocookie.com/embed/'+dataVideo+'?version=3&enablejsapi=1&controls=0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>';

                $('.videoModal .contact__form').append(embedElement);
            } else if ($(this).data('kind') == 'not-embeded'){
                var videoElement = '<video playsinline loop preload="none" poster="'+posterVideo+'" class="s-hero-video__video csVideo" controls style="width: 100%; background-color: #fff !important; max-height: 606px;object-fit: cover;"><source src="'+dataVideo+'" type="video/mp4" /></video>';

                $('.videoModal .contact__form').append(videoElement);
            };
            $('.videoModal .s-cta__body .s-cta__title').html(postTitle);

            $('.videoModal').addClass('active');
            $('body').addClass('overflow-hidden');
        });

        // Close Modal
        $(".videoModal .close").on('click', function () {
            $('.videoModal .contact__form').children().remove();
            $('.videoModal').removeClass('active');
            $('body').removeClass('overflow-hidden');
        });
    }

}

const modal = new Modal();
export default modal;
